<template>
    <div class="toast-container position-fixed bottom-0 end-0 p-3 mb-1" style="z-index: 1090">
        <div v-for="toast in toasts" :key="toast.id" class="toast mb-2 show" :class="getBgClass(toast.severity)"
            role="alert">
            <div class="toast-header">

                <strong class="me-auto" :class="getHeaderClass(toast.severity)">

                    {{ toast.title || getDefaultTitle(toast.severity) }}


                </strong>

                <div class="d-flex align-items-center">
                    <a v-if="toast.actionLink" :href="toast.actionLink" class="btn btn-primary btn-sm">
                        <i class="bi bi-box-arrow-up-right"></i>
                    </a>

                    <button type="button" class="btn-close" @click="() => hideToast(toast.id)"></button>
                </div>

            </div>
            <div class="toast-body" v-html="toast.body"></div>
        </div>
    </div>
</template>

<script
    setup
    lang="ts"
>
import { ref, onMounted, onUnmounted } from 'vue'
import { ToastManagerInstance, ToastMessage } from '../../common/toastManager'
import { ToastSeverity } from '../../common/toastManager'

// Компонент размещается на всех страницах и подписывается на тосты от других компонентов для их рендера

// Расширенный тип тоста
type ToastMessageWithId =
    ToastMessage
    // расширяем: ID для учета
    & { id: number }

// Локальный стейт для рендера
const toasts = ref<ToastMessageWithId[]>([]);

const confing = {
    [ToastSeverity.info]: {
        text: 'text-secondary',
        border: 'border-secondary',
        title: 'Информация',
        bg: '',
    },
    [ToastSeverity.error]: {
        text: 'text-danger',
        border: 'border-danger',
        title: 'Ошибка',
        bg: 'text-bg-danger',
    },
    [ToastSeverity.warn]: {
        text: 'text-warning',
        border: 'border-warning',
        title: 'Внимание',
        bg: 'text-bg-warning',
    },
    [ToastSeverity.success]: {
        text: 'text-success',
        border: 'border-success',
        title: 'Успех',
        bg: 'text-bg-success',
    }
}

const getHeaderClass = (type: ToastSeverity) => confing[type]?.text || '';

const getBgClass = (type: ToastSeverity) => confing[type]?.bg || '';

const getDefaultTitle = (type: ToastSeverity) => confing[type]?.title || 'Уведомление';

const hideToast = (id: number) => {
    const index = toasts.value.findIndex(t => t.id === id)
    if (index > -1) {
        toasts.value.splice(index, 1)
    }
}

const hideOldest = () => {
    toasts.value.splice(0, 1)
}

// Основная функция рендеринга тоста
const show = (t: ToastMessage) => {
    const id = Date.now() + Math.random();

    const newToast =
    {
        id,
        ...t
    };

    toasts.value.push(newToast);

    if (t.autoHide != 0) {
        setTimeout(() => hideToast(id), t.autoHide || 5000);
    }

    // когда слишком много тостов
    if (toasts.value.length > 4) {
        hideOldest();
    }
}

onMounted(() => {
    // При подключении компонента - подписываемся на тосты - и рендерим каждый пришедший тост
    ToastManagerInstance.onToast(show);
});

onUnmounted(() => {
    ToastManagerInstance.unsub(show);
})
</script>